<template>
	<div>
		<div class="container-fluid">
			<div class="row">
				<div class="col-12 col-xl-10">
					<div class="row align-items-center justify-content-between">
						<div class="col-12 col-lg-4">
							<h4 class="mm-0 mb-4" v-if="entity_data != null">Entities: {{ entity_data.name }} </h4>
						</div><!--col-->
					</div><!--row-->
				</div><!--col-->
			</div><!--row-->


			<div class="row">
				<div class="col-6">
					<h5 class="section-title">Groups</h5>

					<button @click="create_group = !create_group" class="mb-2 ml-2 button buttton-small small-button"> 
						<img src="../../../../assets/images/icons/solid/plus_white.svg" width="14" /> New group
					</button>
				    <div v-show="create_group">
				    	<form @submit.prevent="onSubmitNewGroup()">
				    		<div class="form-group input-content">
								<label>Name</label>
								<input type="text" v-model="new_group" class="form-control" v-validate="'required'" name="name">
								<span class="input-error-msg">{{ errors.first('name') }}</span>
							</div>
							<button type="submit" class="button">Submit</button>
				    	</form>
				    </div>

					<table class="table table-bordered">
						<thead>
							<tr>
								<th class="green-content">Name</th>
								<th class="green-content">Categories</th>
								<th class="green-content">Actions</th>
							</tr>
						</thead>
						<tbody v-if="entity_data != null">
							<tr v-for="item in entity_data.groups" >
								<td>{{ item.name }}</td>
								<td>{{ item.categories_str }}</td>
								<td>
									<button type="button" class="button" @click="selectGroup(item.id)">Fields</button>

									<div class="trigger-hidden-content ml-1 d-inline-block">
										<span class=" button">
											<img width="15" src="../../../../assets/images/icons/solid/ellipsis-h_white.svg">
										</span>
										<div class="hidden-content hc-right-bottom">
											<div>
												<ul class="list-unstyled text-left">
													<li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="showModalDeleteGroup(item)">
														<img width="12" class="mr-2" src="../../../../assets/images/icons/solid/trash.svg">
														<span> Delete</span>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="col-sm-6" v-if="selected_group != null">
					<h6 class="section-title">{{ selected_group.name }}</h6>
					<button class="mb-2 ml-2 button buttton-small small-button" @click="create_field = !create_field">
						<img src="../../../../assets/images/icons/solid/plus_white.svg" width="14" /> New field
					</button>

					<div v-show="create_field">
				    	<form @submit.prevent="onSubmitNewField()">
				    		<div class="form-group input-content">
								<label>Category</label>
						        <v-select v-model="new_field.category" :options="categories" name="category_id"></v-select>
								<span class="input-error-msg">{{ errors.first('category_id') }}</span>
							</div>
				    		<div class="form-group input-content">
								<label>Name displayed in the form</label>
								<input type="text" v-model="new_field.name" class="form-control" v-validate="'required'" name="name1">
								<span class="input-error-msg">{{ errors.first('name1') }}</span>
							</div>
							<button type="submit" class="button">Submit</button>
				    	</form>
				    </div>

					<table class="table table-bordered">
						<thead>
							<tr>
								<th class="green-content">Name</th>
								<th class="green-content">Categories</th>
								<th class="green-content">Actions</th>
							</tr>
						</thead>
						<tbody v-if="entity_data != null">
							<tr v-for="item in selected_group.fields" >
								<td>{{ item.form_name }}</td>
								<td>{{ item.category }}</td>
								<td>
									<div class="trigger-hidden-content ml-1 d-inline-block">
										<span class=" button">
											<img width="15" src="../../../../assets/images/icons/solid/ellipsis-h_white.svg">
										</span>
										<div class="hidden-content hc-right-bottom">
											<div>
												<ul class="list-unstyled text-left">
													<li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="showModalDeleteField(item)">
														<img width="12" class="mr-2" src="../../../../assets/images/icons/solid/trash.svg">
														<span> Delete</span>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<b-modal v-model="show_delete_group" title="Delete group" @ok="deleteGroup" cancel-title="No" ok-title="Yes">
	    	<div v-if="group_to_delete != null">
				<p class="mb-2">
					Are you sure you want to delete the group {{ group_to_delete.name }}?
				</p>
			</div>
		</b-modal>

		<b-modal v-model="show_delete_field" title="Delete field" @ok="deleteField" cancel-title="No" ok-title="Yes">
	    	<div v-if="field_to_delete != null">
				<p class="mb-2">
					Are you sure you want to delete the field {{ field_to_delete.form_name }}?
				</p>
			</div>
		</b-modal>
	</div>
</template>

<script>
	export default {
		data : function(){
			return {
				id : this.$route.params.id,
				entity_data : null,
				create_group : false,
				create_field : false,
				new_group : '',
				new_field : {
					name : '',
					category : null
				},
				selected_group : null,
				categories : [],
				show_delete_field : false,
				show_delete_group : false,
				group_to_delete : null,
				field_to_delete : null
			}
		},

		created : function(){
			this.getEntity();
			this.getCategories();
		},

		methods : {
			getEntity : function(){
				this.$store.dispatch('getEntityTaggable', { id : this.id }).then((res) => {
					this.entity_data = res.data.data;

					if(this.selected_group){
						this.selectGroup(this.selected_group.id);
					}
				}).catch((error) => {
					console.log(error);
				})
			},
			getCategories : function(){
				var filters = {
					select : true
				}

				this.$store.dispatch('getCategories', {
					filters : filters
				}).then((res) => {
					this.categories = res.data.data;
				}).catch((error) => {
					console.log(error);
				});
			},
			onSubmitNewGroup : function(){
				this.$validator.validateAll().then((result) => {
				//	if(result){
						var params = {
							id : this.id,
							name : this.new_group
						}

						this.$store.dispatch('createEntityTaggableGroup', params).then((res) => {
							console.log(res);

							this.new_group = '';
							this.create_group = false;
							this.getEntity();
						}).catch((error) => {
							console.log(error);
						});
					//}
				});
			},
			selectGroup : function(group_id){
				for(var i in this.entity_data.groups){
					if(this.entity_data.groups[i].id == group_id){
						this.selected_group = this.entity_data.groups[i];
					}
				}
			},
			onSubmitNewField : function(){
				this.$validator.validateAll().then((result) => {
						

						var params = {
							id : this.id,
							group_id : this.selected_group.id,
							name : this.new_field.name,
							category_id : this.new_field.category.value
						}

						this.$store.dispatch('addFieldToGroup', params).then((res) => {
							

							this.new_field.name = '';
							this.new_field.category = null;

							this.create_field = false;
							this.getEntity();
						}).catch((error) => {
							console.log(error);
						});
					
				});
			},

			showModalDeleteGroup : function(group){
				this.group_to_delete = group;
				this.show_delete_group = true;
			},
			showModalDeleteField : function(field){
				this.field_to_delete = field;
				this.show_delete_field = true;
			},
			deleteGroup : function(){

				var params = {
					id : this.id,
					group_id : this.group_to_delete.id
				}

				this.$store.dispatch('deleteEntityTaggableGroup', params).then((res) => {

					this.show_delete_group = false;
					this.group_to_delete = null;
					this.getEntity();
				}).catch((error) => {
					console.log(error);
				});
			},
			deleteField : function(){

				var params = {
					id : this.id,
					group_id : this.selected_group.id,
					field_id : this.field_to_delete.id
				}

				this.$store.dispatch('deleteEntityTaggableField', params).then((res) => {

					this.show_delete_field = false;
					this.field_to_delete = null;
					this.getEntity();
				}).catch((error) => {
					console.log(error);
				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/admin/configs/entities-taggables/AdminEntityTaggableDetailComponent.vue